import commonActions from '../common/common.actions';
import loginActions from '../login/login.actions';
import homeActions from '../home/home.actions';
import attentionsActions from '../attentions/attentions.actions';
// [GLOBAL ACTIONS] IMPORT MODULE ACTIONS

export default {
    common: commonActions,
    login: loginActions,
    home: homeActions,
    attentions: attentionsActions,
    // [GLOBAL ACTIONS] EXPORT ACTIONS
};
